import { ErrorsType } from '../types'

function getGroupErrorsCount(errors: Array<ErrorsType> = [], groupName: string): number {
  const [error] = filterGroup(errors, groupName)
  return error?.total || 0
}

function filterGroup(errors: Array<ErrorsType> = [], groupName: string): Array<ErrorsType> {
  return errors.filter((error) => error.group === groupName)
}
/** Helper class to identify plagiarism and its severity depending on error count. */
class Plagiarism {
  static MIN_THRESHOLD = 1

  static isTextPlagiarism(text = ''): boolean {
    return text.toLowerCase() === 'plagiarism'
  }

  constructor(private errors: Array<ErrorsType> = []) {
    this.errors = errors
  }

  get isSignificant(): boolean {
    return this.count >= 10
  }

  get isNormal(): boolean {
    return this.isPresent && this.count < 10
  }

  get isPresent(): boolean {
    return this.count >= Plagiarism.MIN_THRESHOLD
  }

  get count(): number {
    return getGroupErrorsCount(this.errors, 'Plagiarism')
  }
}

export default Plagiarism
export { Plagiarism as PlagiarismHelper }
